import { call, put, takeLatest, select } from 'redux-saga/effects';
import databaseAnalysisService from '../../../services/databaseAnalysisService';
import {
  fetchInit,
  fetchInitSuccess,
  fetchInitFailure,
  fetchDatabaseAnalyses,
  fetchDatabaseAnalysesSuccess,
  fetchDatabaseAnalysesFailure,
  fetchDatabaseAnalysisById,
  fetchDatabaseAnalysisByIdSuccess,
  fetchDatabaseAnalysisByIdFailure,
  addDatabaseAnalysis,
  addDatabaseAnalysisSuccess,
  addDatabaseAnalysisFailure,
  updateDatabaseAnalysis,
  updateDatabaseAnalysisSuccess,
  updateDatabaseAnalysisFailure,
  deleteDatabaseAnalysis,
  deleteDatabaseAnalysisSuccess,
  deleteDatabaseAnalysisFailure,
  bulkDeleteDatabaseAnalyses,
  bulkDeleteDatabaseAnalysesSuccess,
  bulkDeleteDatabaseAnalysesFailure,
  exportDatabaseAnalysesToExcel,
  exportDatabaseAnalysesToExcelSuccess,
  exportDatabaseAnalysesToExcelFailure,
  exportDatabaseAnalysesToPdf,
  exportDatabaseAnalysesToPdfSuccess,
  exportDatabaseAnalysesToPdfFailure,
  exportDatabaseUsageReportToExcel,
  exportDatabaseUsageReportToExcelSuccess,
  exportDatabaseUsageReportToExcelFailure,
  exportDatabaseUsageReportToPdf,
  exportDatabaseUsageReportToPdfSuccess,
  exportDatabaseUsageReportToPdfFailure,
  selectFilterName,
  selectFilterCode,
  selectFilterUnitId,
  selectFilterDatabaseType,
  selectFilterStatus,
  selectFilterLastSyncFrom,
  selectFilterLastSyncTo,
} from './slice';

function* handleFetchInit() {
  try {
    const response = yield call(databaseAnalysisService.getInit);
    yield put(fetchInitSuccess(response));
  } catch (error) {
    yield put(fetchInitFailure(error.message));
  }
}

function* handleFetchDatabaseAnalyses(action) {
  try {
    const response = yield call(databaseAnalysisService.getDatabaseAnalyses, action.payload);
    yield put(fetchDatabaseAnalysesSuccess(response));
  } catch (error) {
    yield put(fetchDatabaseAnalysesFailure(error.message));
  }
}

function* handleFetchDatabaseAnalysisById(action) {
  try {
    const response = yield call(databaseAnalysisService.getDatabaseAnalysisById, action.payload);
    yield put(fetchDatabaseAnalysisByIdSuccess(response));
  } catch (error) {
    yield put(fetchDatabaseAnalysisByIdFailure(error.message));
  }
}

function* handleAddDatabaseAnalysis(action) {
  try {
    const response = yield call(databaseAnalysisService.createDatabaseAnalysis, action.payload);
    yield put(addDatabaseAnalysisSuccess(response));
  } catch (error) {
    yield put(addDatabaseAnalysisFailure(error.message));
  }
}

function* handleUpdateDatabaseAnalysis(action) {
  try {
    const response = yield call(databaseAnalysisService.updateDatabaseAnalysis, action.payload);
    yield put(updateDatabaseAnalysisSuccess(response));
  } catch (error) {
    yield put(updateDatabaseAnalysisFailure(error.message));
  }
}

function* handleDeleteDatabaseAnalysis(action) {
  try {
    const response = yield call(databaseAnalysisService.deleteDatabaseAnalysis, action.payload);
    yield put(deleteDatabaseAnalysisSuccess(response));
  } catch (error) {
    yield put(deleteDatabaseAnalysisFailure(error.message));
  }
}

function* handleBulkDeleteDatabaseAnalyses(action) {
  try {
    const response = yield call(databaseAnalysisService.bulkDeleteDatabaseAnalyses, action.payload);
    yield put(bulkDeleteDatabaseAnalysesSuccess(response));
  } catch (error) {
    yield put(bulkDeleteDatabaseAnalysesFailure(error.message));
  }
}

function* handleExportDatabaseAnalysesToExcel() {
  try {
    const filterName = yield select(selectFilterName);
    const filterCode = yield select(selectFilterCode);
    const filterUnitId = yield select(selectFilterUnitId);
    const filterDatabaseType = yield select(selectFilterDatabaseType);
    const filterStatus = yield select(selectFilterStatus);
    const filterLastSyncFrom = yield select(selectFilterLastSyncFrom);
    const filterLastSyncTo = yield select(selectFilterLastSyncTo);

    const normalizeFilter = (filterValue) => {
      const values = Array.isArray(filterValue) ? filterValue : (filterValue !== null && filterValue !== undefined ? [filterValue] : []);
      const unique = [...new Set(values)];
      return unique.length === 1 ? unique[0] : undefined;
    };

    const params = {
      name: filterName,
      code: filterCode,
      unitId: normalizeFilter(filterUnitId),
      databaseType: normalizeFilter(filterDatabaseType),
      status: normalizeFilter(filterStatus),
      lastSyncFrom: filterLastSyncFrom,
      lastSyncTo: filterLastSyncTo,
    };

    const response = yield call(databaseAnalysisService.exportDatabaseAnalysesToExcel, params);
    yield put(exportDatabaseAnalysesToExcelSuccess(response));
  } catch (error) {
    yield put(exportDatabaseAnalysesToExcelFailure(error.message));
  }
}

function* handleExportDatabaseAnalysesToPdf() {
  try {
    const filterName = yield select(selectFilterName);
    const filterCode = yield select(selectFilterCode);
    const filterUnitId = yield select(selectFilterUnitId);
    const filterDatabaseType = yield select(selectFilterDatabaseType);
    const filterStatus = yield select(selectFilterStatus);
    const filterLastSyncFrom = yield select(selectFilterLastSyncFrom);
    const filterLastSyncTo = yield select(selectFilterLastSyncTo);

    const normalizeFilter = (filterValue) => {
      const values = Array.isArray(filterValue) ? filterValue : (filterValue !== null && filterValue !== undefined ? [filterValue] : []);
      const unique = [...new Set(values)];
      return unique.length === 1 ? unique[0] : undefined;
    };

    const params = {
      name: filterName,
      code: filterCode,
      unitId: normalizeFilter(filterUnitId),
      databaseType: normalizeFilter(filterDatabaseType),
      status: normalizeFilter(filterStatus),
      lastSyncFrom: filterLastSyncFrom,
      lastSyncTo: filterLastSyncTo,
    };

    const response = yield call(databaseAnalysisService.exportDatabaseAnalysesToPdf, params);
    yield put(exportDatabaseAnalysesToPdfSuccess(response));
  } catch (error) {
    yield put(exportDatabaseAnalysesToPdfFailure(error.message));
  }
}

function* handleExportDatabaseUsageReportToExcel(action) {
  try {
    const response = yield call(databaseAnalysisService.exportDatabaseUsageReportToExcel, action.payload);
    yield put(exportDatabaseUsageReportToExcelSuccess(response));
  } catch (error) {
    yield put(exportDatabaseUsageReportToExcelFailure(error.message));
  }
}

function* handleExportDatabaseUsageReportToPdf(action) {
  try {
    const response = yield call(databaseAnalysisService.exportDatabaseUsageReportToPdf, action.payload);
    yield put(exportDatabaseUsageReportToPdfSuccess(response));
  } catch (error) {
    yield put(exportDatabaseUsageReportToPdfFailure(error.message));
  }
}

export function* watchDatabaseAnalysisActions() {
  yield takeLatest(fetchInit.type, handleFetchInit);
  yield takeLatest(fetchDatabaseAnalyses.type, handleFetchDatabaseAnalyses);
  yield takeLatest(fetchDatabaseAnalysisById.type, handleFetchDatabaseAnalysisById);
  yield takeLatest(addDatabaseAnalysis.type, handleAddDatabaseAnalysis);
  yield takeLatest(updateDatabaseAnalysis.type, handleUpdateDatabaseAnalysis);
  yield takeLatest(deleteDatabaseAnalysis.type, handleDeleteDatabaseAnalysis);
  yield takeLatest(bulkDeleteDatabaseAnalyses.type, handleBulkDeleteDatabaseAnalyses);
  yield takeLatest(exportDatabaseAnalysesToExcel.type, handleExportDatabaseAnalysesToExcel);
  yield takeLatest(exportDatabaseAnalysesToPdf.type, handleExportDatabaseAnalysesToPdf);
  yield takeLatest(exportDatabaseUsageReportToExcel.type, handleExportDatabaseUsageReportToExcel);
  yield takeLatest(exportDatabaseUsageReportToPdf.type, handleExportDatabaseUsageReportToPdf);
}
